<template>
  <div>
    Comment #{{index + 1}} ..................................................................<br>
    Author: <b>{{author}}</b><br>
    Time: <b>{{formatTime(time)}}</b><br>
    <i>{{text}}</i><br>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    index: Number,
    author: String,
    time: String,
    text: String,
  },

  methods: {
    formatTime(time) {
      return moment(time).local().format('YYYY-MM-DD HH:mm:ss');
    },
  },
};
</script>
